@if (turn(); as currentTurn) {
<app-turn [turn]="currentTurn" [turnDistance]="turnDistance()" [showLanes]="roadLanesVisible()"></app-turn>
}

<app-speedlimit
  [hasTurn]="hasTurn()"
  [speedLimit]="speedLimit()"
  [floatingInfoVisible]="floatingInfoVisible()">
</app-speedlimit>

<div [ngClass]="{'hide-navigation-hud': mobileVisiblePanel() == 'car'}" class="navigation-hud" data-testid="nav-hud-container">
  <!-- The better-route offer is a state of the plan card itself, see
       app-navigation-plan-better-route. -->
  <app-navigation-plan></app-navigation-plan>
</div>
